import { render, staticRenderFns } from "./PayFlowDesktop.vue?vue&type=template&id=1242ac37&scoped=true&"
import script from "./PayFlowDesktop.vue?vue&type=script&lang=js&"
export * from "./PayFlowDesktop.vue?vue&type=script&lang=js&"
import style0 from "./PayFlowDesktop.vue?vue&type=style&index=0&id=1242ac37&prod&scoped=true&lang=css&"
import style1 from "./PayFlowDesktop.vue?vue&type=style&index=1&id=1242ac37&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1242ac37",
  null
  
)

export default component.exports